
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorChatActivo } from '../../controlador';
    import opciones from './barra-ventas-opciones.vue';
    import pedidos from './barra-ventas-pedidos.vue';
    import facturas from './barra-ventas-facturas.vue';
    import editar_cliente from './barra-ventas-editar-cliente.vue';
    import { Controlador as ControladorPrincipal } from '../../../controlador';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            opciones,
            pedidos,
            facturas,
            editar_cliente,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorChatActivo;
        public get ControladorBarras() { return this.Controlador.ControladorBarrasLaterales; }
        public get Chat() { return this.Controlador.Chat; }
        public get SubModo() { return this.ControladorBarras.Vista.SubModo; }
        public set SubModo( x: string ) { this.ControladorBarras.Vista.SubModo = x; }
        public get Modo() { return this.ControladorBarras.Vista.Modo; }
        public set Modo( x: string ) { this.ControladorBarras.Vista.Modo = x; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.ReservarEspacioDerecha.Espacio; }
        public Abierto: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {


            this.Eventos.push( this.ControladorBarras.Vista.Menu.onAbierto.subscribe( () =>
            {
                this.Abierto = this.ControladorBarras.Vista.Menu.Abierto;

                if ( !this.Abierto )
                    this.Controlador.Vista.ReservarEspacioDerecha.Espacio = 0;

            } ) );


            this.Eventos.push( this.ControladorBarras.Vista.onModo.subscribe( () =>
            {
                if ( this.Modo )
                {
                    ControladorPrincipal.Vista.OcultarMenu();
                    this.ControladorBarras.Vista.Menu.Abierto = true;
                } else
                {
                    ControladorPrincipal.Vista.MenuOculto = false;
                    this.ControladorBarras.Vista.Menu.Abierto = false;
                }



            } ) );
        }

    }
